// actions
const actions = {
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions/actions.js